import(/* webpackMode: "eager" */ "/home/jihad/Torongo-Gadgets/torongo-frontend/src/app/shop/page.tsx");
